/** Same allow-list as backend require_manager. */

export function canManageDc(role: string | null | undefined): boolean {
  return role === 'dc_manager' || role === 'admin'
}
